<template>
  <v-layout row :justify-end="!mosaic" :justify-start="mosaic" v-if="actions ? actions.length : false">
    <v-flex v-if="$vuetify.breakpoint.xsOnly">
      <nx-show-more>
        <v-list dense>
          <template v-for="(action, index) in actions">
            <nx-list-action-preview :key="index" list v-if="action.type === 'preview'" :id="item.id" :type="item.type" />
            <nx-list-action-user-comments :key="index" list v-if="action.type === 'user-comments'" :id="item.id" />
            <nx-list-action-metadata :key="index" list v-if="action.type === 'metadata'" :id="item.id" :type="item.type" />
            <nx-list-action-entity-tree :key="index" list v-if="action.type === 'entity-tree'" :id="item.id" :type="item.type" />
            <nx-list-action-link :key="index" list v-if="action.type === 'link'" :url="action.url || url" />
            <nx-list-action-comment-moderation :key="index" list v-if="action.type === 'comment-moderation'"
                                               :id="item.id" :type="item.type" v-bind="metadata"
                                               v-on="$listeners" />
            <nx-list-action-question-moderation :key="index" list v-if="action.type === 'question-moderation'"
                                                :id="item.id" :type="item.type" v-bind="metadata"
                                                @updateItem="$emit('updateItem', item)" />
            <nx-list-action-create-entity :key="index" list v-if="action.type === 'create-entity'"
                                          :entity="action.entity"
                                          :item="item" />
            <nx-list-action-delete-entity :key="index" list v-if="action.type === 'delete-entity'"
                                          :entity="item.type" :entity-id="item.id"
                                          @delete="$emit('refresh', item)" />
            <template v-if="actionCustomComponent(action.type)">
              <component :is="actionCustomComponent(action.type)" :key="index" list
                         :item="item"
                         v-bind="item" />
            </template>
          </template>
          <nx-list-action-content-schedules
            list
            v-if="showContentSchedulesActions"
            :id="item.id"
            :action-publish-cancel="!!getActionByType('content-publish-schedule-cancel')"
            :action-unpublish-cancel="!!getActionByType('content-unpublish-schedule-cancel')" />
        </v-list>
      </nx-show-more>
    </v-flex>
    <template v-else>
        <v-layout justify-start row>
          <v-scroll-x-transition hide-on-leave>
            <v-layout shrink row v-show="hovered">
              <template v-for="(action, index) in actions">
                <nx-list-action-preview :key="index" v-if="action.type === 'preview'" :id="item.id" :type="item.type" />
                <nx-list-action-user-comments :key="index" v-if="action.type === 'user-comments'" :id="item.id" />
                <nx-list-action-metadata :key="index" v-if="action.type === 'metadata'" :id="item.id" :type="item.type" />
                <nx-list-action-entity-tree :key="index" v-if="action.type === 'entity-tree'" :id="item.id" :type="item.type" />
                <nx-list-action-comment-moderation :key="index" v-if="action.type === 'comment-moderation'"
                                                   :id="item.id" :type="item.type" v-bind="metadata"
                                                   v-on="$listeners"/>
                <nx-list-action-question-moderation :key="index" v-if="action.type === 'question-moderation'"
                                                    :id="item.id" :type="item.type" v-bind="metadata"
                                                    @updateItem="$emit('updateItem', item)"
                />
                <nx-list-action-create-entity :key="index" v-if="action.type === 'create-entity'"
                                              :entity-types="action.entityTypes"
                                              :item="item"/>
                <nx-list-action-delete-entity :key="index" v-if="action.type === 'delete-entity'"
                                              :entity="item.type" :entity-id="item.id"
                                              @delete="$emit('refresh', item)" />
                <template v-if="actionCustomComponent(action.type)">
                  <component :is="actionCustomComponent(action.type)" :key="index"
                             :item="item"
                             v-bind="item" />
                </template>
              </template>
              <nx-list-action-content-schedules
                v-if="showContentSchedulesActions"
                :id="item.id"
                :action-publish-cancel="!!getActionByType('content-publish-schedule-cancel')"
                :action-unpublish-cancel="!!getActionByType('content-unpublish-schedule-cancel')"
                @refreshItem="$emit('refreshItem', item)"
              />
            </v-layout>
          </v-scroll-x-transition>
          <nx-list-action-link v-if="getActionByType('link')"
                               :url="getActionByType('link').url || url" />
        </v-layout>
    </template>
  </v-layout>
</template>

<script>
import NxShowMore from '@/components/menu/ShowMore';
import NxListActionMetadata from '@/components/list/components/actions/ListActionMetadata';
import NxListActionLink from '@/components/list/components/actions/ListActionLink';
import NxListActionPreview from '@/components/list/components/actions/ListActionPreview';
import NxListActionCommentModeration from '@/components/list/components/actions/ListActionCommentModeration';
import NxListActionUserComments from '@/components/list/components/actions/ListActionUserComments';
import NxListActionContentSchedules from '@/components/list/components/actions/ListActionContentSchedules';
import NxListActionQuestionModeration from '@/components/list/components/actions/ListActionQuestionModeration';
import NxListActionEntityTree from '@/components/list/components/actions/ListActionEntityTree';
import NxListActionCreateEntity from '@/components/list/components/actions/ListActionCreateEntity';
import isObject from 'lodash/isObject';
import NxListActionDeleteEntity from '@/components/list/components/actions/ListActionDeleteEntity.vue';
import { getCustomListItemActionComponentForType } from '@/components/list/config';

export default {
  components: {
    NxListActionDeleteEntity,
    NxListActionUserComments,
    NxListActionCommentModeration,
    NxListActionPreview,
    NxListActionLink,
    NxListActionMetadata,
    NxShowMore,
    NxListActionContentSchedules,
    NxListActionQuestionModeration,
    NxListActionEntityTree,
    NxListActionCreateEntity,
  },
  props: {
    item: Object,
    mosaic: Boolean,
    hovered: Boolean,
    metadata: {
      type: [Object, Array],
      default: () => ({}),
    },
  },
  computed: {
    title() {
      return this.item.title;
    },
    actions() {
      return this.item.actions.map((action) => {
        if (isObject(action)) {
          return action;
        }
        // Backwards compatibility for string actions
        return { type: action };
      });
    },
    url() {
      return this.item.url;
    },
    showContentSchedulesActions() {
      return this.getActionByType('content-publish-schedule-cancel')
        || this.getActionByType('content-unpublish-schedule-cancel');
    },
  },
  methods: {
    actionCustomComponent(action) {
      return getCustomListItemActionComponentForType(action);
    },
    async addToBag() {
      await this.$store.dispatch('bag/ADD_CONTENT', this.item);
    },
    getActionByType(type) {
      return this.actions.find((action) => {
        if (action.type === type) {
          return action;
        }
        return false;
      });
    },
  },
};
</script>
